import { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Alert, Col, Row } from "reactstrap";
import DavetliEtkinlikService from "../../services/srv-davetli/DavetliEtkinlikService";
import { GuestEventInfoCard } from "../../containers/GuestEvent/Detail/GuestEventInfoCard";
import { GuestParticipantCard } from "../../containers/GuestEvent/Detail/GuestParticipantCard";
import LoadingPanel from "../../components/sys-toolbox/LoadingPanel";

function GuestEventDetailPage() {
  const { id } = useParams();
  const { t } = useTranslation();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setLoadError(false);
    setEvent(null);

    DavetliEtkinlikService.getById(id)
      .then((data) => {
        if (cancelled) return;
        setEvent(data || null);
      })
      .catch(() => {
        if (cancelled) return;
        setLoadError(true);
        setEvent(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [id]);

  if (loading) return <LoadingPanel />;

  if (loadError || !event?.davetlI_ETKINLIK_TANIM_ID) {
    return (
      <Alert color="danger">{t("guest_event_not_found")}</Alert>
    );
  }

  return (
    <Fragment>
      <Row>
        <Col className="mb-3" lg="12" md="12" sm="12" xs="12">
          <GuestEventInfoCard event={event} />
        </Col>
      </Row>
      <GuestParticipantCard event={event} />
    </Fragment>
  );
}

export { GuestEventDetailPage };
